import axios from "axios";

const global_var = {
  CLOUD_ASSET_STORAGE_URL:
    process.env.REACT_APP_CLOUD_ASSET_STORAGE_URL ||
    "https://cs-fileuploads-dev.s3.ap-south-1.amazonaws.com/uploaded_test",
  FILE_UPLOAD_S3_FOLDER: process.env.REACT_APP_FILE_UPLOAD_S3_FOLDER || "uploaded_test",
  SCRATCH_ENDPOINT:
    process.env.REACT_APP_SCRATCH_ENDPOINT || "https://vc3.dev99lms.com/",
  SCRATCHJR_ENDPOINT: 
    process.env.REACT_APP_SCRATCHJR_ENDPOINT ||'https://vc2jr.dev99lms.com',
  SQLPAD_ENDPOINT:
    process.env.REACT_APP_SQLPAD_ENDPOINT || "https://sql.dev99lms.com/sqlpad",
  CODE_COMPAT_ENDPOINT: process.env.REACT_APP_CODE_COMPAT_ENDPOINT || "https://abc.dev99lms.com/",
  TYPING_NINJA_ENDPOINT: process.env.REACT_APP_TYPING_NINGA_ENDPOINT || 'https://typingninja-game.dev99lms.com/',
  WEB_TYPIST_ENDPOINT:process.env.REACT_APP_WEB_TYPIST_ENDPOINT || "https://webtypist.cybersquare.org/#us",
  GBIRD_ENDPOINT:
    "https://99lmsfileuploadfolder.s3.ap-south-1.amazonaws.com/uploaded/games/demogames/maths/geekybirdNumeric/index.html",
  GBIRD_P_ENDPOINT:
    "https://99lmsfileuploadfolder.s3.ap-south-1.amazonaws.com/uploaded/games/demogames/customizeGeekyBird/index.html",
  SUPERADMIN_ROLE_ID: 1,
  ADMIN_ROLE_ID: 2,
  STUDENT_ROLE_ID: 3,
  TEACHER_ROLE_ID: 7,
  SYSTEMUSER_ROLE_ID: 13,
  SUPERVISOR_ROLE_ID: 18,
  SUPERVISOR_ROLE_IDS: "5eb286c23e6c3959c1f965c1",
  MITAPPINVENTOR_ENDPOINT:
    process.env.MITAPPINVENTOR_ENDPOINT || "https://app-inventor.cybersquare.org/",
  MAKECODE_ENDPOINT: process.env.REACT_APP_MAKECODE_ENDPOINT || "https://makecode.dev99lms.com",
  HOSTED_VIDEO_ENDPOINT: process.env.REACT_APP_HOSTED_VIDEO_ENDPOINT || "https://d1ifuv9vk7qn2.cloudfront.net/",
  TUX_PAINT_ENDPOINT: process.env.REACT_APP_TUX_PAINT_ENDPOINT || "https://cs-paint.dev99lms.com/",
};

const projectStacks = {
  "Programming Languages": [
    {
      projectStackName: "python",
    },
    {
      projectStackName: "html_css",
    },
    // {
    //   projectStackName: "javascript",
    // },
  ],
  "Visual Coding": [
    {
      projectStackName: "vc3",
    },
    {
      projectStackName: "scratchjr",
    },
    {
      projectStackName: "mit_app_inventor",
    }
  ],
  Database: [
    {
      projectStackName: "sql2",
    },
  ],
  Games: [
    {
      projectStackName: "codeCombat_game",
    },
    {
      projectStackName: "geekyBird_game",
    },
    {
      projectStackName: "geekyBird_game_programmable",
    },
  ],
  "Typing Games": [
    {
      projectStackName: "dance_mat_typing",
    },
    {
      projectStackName: "typing_ninja",
    },
    {
      projectStackName: "web_typist",
    }
  ],
  "Robotics": [
    {
      projectStackName: "makecode",
    }
  ],
  "Drawing": [
    {
      projectStackName: "tuxpaint",
    }
  ],
};

const projectCategoryMapping = {
  "Programming Languages": {
    'sortOrder': 1
  },
  "Visual Coding": {
    'sortOrder': 2
  },
  "Database": {
    'sortOrder': 3
  },
  "Games": {
    'sortOrder': 4
  },
  "Typing Games": {
    'sortOrder' : 5
  },
  "Robotics": {
    'sortOrder': 6
  },
  "Drawing": {
    'sortOrder': 7
  }
};

const lms_v2_api = axios.create({
  baseURL: process.env.REACT_APP_LMS_V2_API || "https://api-v2.dev99lms.com",
  // baseURL: "http://127.0.0.1:7000",
  headers: {
    "Content-Type": "application/json",
    "cs-application-type": "web-cs-lab",
    "cs-app-version": "v1"
  },
});

const video_upload_signed_url_endpoint = axios.create({
  baseURL: process.env.REACT_APP_FILE_UPLOAD_SIGNED_URL_API_GATEWAY_ENDPOINT || "https://dzn7i22ite.execute-api.ap-south-1.amazonaws.com/default/",
  headers: {
    "Content-Type": "application/json",
  },
});

const s3_signed_url_endpoint = axios.create({
  baseURL:process.env.REACT_APP_CS_API_GATEWAY_ENDPOINT || "https://gateway.dev99lms.com/",
  headers:{
    "Content-Type": "application/json"
  }
})

s3_signed_url_endpoint.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

lms_v2_api.interceptors.request.use(
  function (config) {
    // const authToken = localStorage.getItem("token");
    const authToken = sessionStorage.getItem('token');
    if (authToken) {
      config.headers["Authorization"] = authToken;
    }

    return config;
  },

  function (error) {
    return Promise.reject(error);
  }
);


lms_v2_api.interceptors.response.use(
  function (response) {
    if(response.headers.get('Refresh-Token')){
      // localStorage.setItem('token', response.headers.get('Refresh-Token'))
      sessionStorage.setItem('token', response.headers.get('Refresh-Token'));
    }
    return response
  }
)

export { lms_v2_api, global_var, projectStacks, projectCategoryMapping, video_upload_signed_url_endpoint, s3_signed_url_endpoint};
